import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../auth.service';

@Component({
  selector: 'grid-apps-login',
  standalone: true,
  imports: [],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private location: Location,
  ) {}

  ngOnInit(): void {
    this.authService.logout();
    this.location.historyGo(-2);
  }
}
